import type { MenuGroup } from "../../services/types/menu";
import { useGetAllMenuGroupsForMenu } from "./useGetAllMenuGroupsForMenu";

export const useGetMenuGroups = (menuId: string, menuGroupId: string | undefined): MenuGroup[] => {
  const allGroups = useGetAllMenuGroupsForMenu(menuId);
  return allGroups.filter((group) => group.menuGroupId === menuGroupId);
};
